/**
 * 吸顶后时间浮层
 */

'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, PanResponder, ScrollView} from 'react-native';
import { observer, inject } from 'mobx-react';

import { QPopupLayer as PopupLayer} from '@qnpm/q-popup-layer';

import styles from './style';
import {scroll} from "../../../../common/utils";
import ReactDom from "react-dom";


@inject(stores => {
    const {lowPriceDataStore} = stores,
        {
            lowPriceData,
            selectedFilter,
            setFilter,
            searchFilterModalVisible,
            handleSearchFilterModal} = lowPriceDataStore,
        {filters} = lowPriceData;


    return {
        filters,
        setFilter,
        selectedFilter,
        searchFilterModalVisible,
        handleSearchFilterModal
    };
})

@observer
class SearchFilter extends Component {
    constructor(props) {
        super(props);
    }

    selectFilter(item) {
        this.props.setFilter(item.title);
        this.props.handleSearchFilterModal();
        scroll(ReactDom.findDOMNode(this.props.scrollRef), this.props.scrollTop + 1);
        GodEye.log({
            r: 'search_filter_modal_click',
            title: item.title
        })
    }

    closeFilterModal = (e) => {
        this.props.handleSearchFilterModal(e);
        GodEye.log({
            r: 'search_filter_modal_close'
        })
    };

    render() {
        let {filters, searchFilterModalVisible, selectedFilter} = this.props;
        if(!filters) {
            return <View />
        }

        return (
            <PopupLayer
                swipeBackControl={true}
                maskClosable={true}
                title='选择时间范围'
                perHeight={75}
                style={styles.filterLayer}
                onClose = {this.closeFilterModal}
                visible={searchFilterModalVisible}
            >
                {
                    filters.map((item) => {
                        let active = item.title === selectedFilter;
                        return <View style={styles.filterModalWrapper} key={item.title}>
                            <TouchableOpacity style={styles.filterModalItem} onPress={()=>{this.selectFilter(item)}}>
                                <View style={styles.filterModalText}>
                                    <Text style={[styles.filterItemText, active ? styles.filterItemActiveText :{}]}>{item.title}</Text>
                                    <Text style={[styles.filterItemAfterText]}>（{item.subTitle}）</Text>
                                </View>

                                {/*没有用Icon组件的原因是 Icon组件在adr和ios上展示的颜色不同*/}
                                {active ?  <Text style={styles.checkIcon}>{'\ue43d'}</Text> : null}
                            </TouchableOpacity>
                            <View style={styles.border}/>
                        </View>
                    })
                }
            </PopupLayer>
        )
    }
}

export default SearchFilter;
